import { defineComponent as _defineComponent } from 'vue'
import CustomTableFilters from '@/components/tableWithActions/CustomTableFilters.vue';
import { useI18n } from '@/composables/i18n';
import { computed, ref } from 'vue';
import { BendProductionHistoryFilterValues } from './BendProductionHistoryFilterValues';
import { areArraysEqual } from '@/utils/array';
import { isNil } from '@/utils/misc';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendProductionHistoryFilters',
  emits: ["filters-change"],
  setup(__props, { emit }: { emit: ((
      e: 'filters-change',
      filters: BendProductionHistoryFilterValues,
      areApplying: boolean,
    ) => void), expose: any, slots: any, attrs: any }) {



const defaultFilterValues: BendProductionHistoryFilterValues = Object.freeze({
  partName: [],
  partDescription: [],
  partOriginator: [],
  material: [],
  thicknessMm: [],
  bendsPerPart: [],
  partWeightKg: [null, null] as [number | null, number | null],
  users: [],
});

const TEXT_LIST_FILTERS = [
  'partName',
  'partDescription',
  'partOriginator',
  'material',
  'thicknessMm',
  'bendsPerPart',
  'users',
];

const filters = ref(structuredClone(defaultFilterValues));

const { t } = useI18n();

function clearAllFilters() {
  filters.value = structuredClone(defaultFilterValues);
  onFiltersApplied();
}

function onFiltersApplied() {
  emitFilters();
}

function emitFilters() {
  emit('filters-change', structuredClone(filters.value), areApplying.value);
}

const areTextListFiltersApplying = computed<boolean>(() =>
  TEXT_LIST_FILTERS.some(
    (textListFilterKey) =>
      !areArraysEqual(
        filters.value[
          textListFilterKey as keyof BendProductionHistoryFilterValues
        ] as string[],
        defaultFilterValues[
          textListFilterKey as keyof BendProductionHistoryFilterValues
        ] as string[],
      ),
  ),
);

const areApplying = computed<boolean>(
  () =>
    areTextListFiltersApplying.value ||
    !(
      isNil(filters.value.partWeightKg[0]) &&
      isNil(filters.value.partWeightKg[1])
    ),
);

return { __sfc: true,emit, defaultFilterValues, TEXT_LIST_FILTERS, filters, t, clearAllFilters, onFiltersApplied, emitFilters, areTextListFiltersApplying, areApplying, CustomTableFilters }
}

})